import { useState } from 'react';

function useInitial(value) {
  const [initialValue] = useState(value);
  return initialValue;
}

export { useInitial };
//# sourceMappingURL=use-initial.js.map
